// extracted by mini-css-extract-plugin
export default {"image":"BY-z","loaded":"CY-z"};